import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardCalendarQuery } from '../types';

/**
 * typeguard for DataCardCalendarQuery
 * @param DataCardCalendarQuery object passed to transformer
 */
export const isValidDataCardCalendar = (obj: DataCardCalendarQuery): boolean => Boolean(obj?.data?.getCardGpCalendarWidget && !isEmptyObject(obj.data.getCardGpCalendarWidget));
